import React from 'react';
import { PaddingContainer, WidthContainer } from '@components';
import classNames from 'classnames';

import * as styles from './WeAlsoWorkWith.module.scss';
import { weAlsoWorkWith } from '@store/IoTData';

export const WeAlsoWorkWith: React.FC = () => {
	return (
		<PaddingContainer className="gray-bg">
			<WidthContainer>
				<div className='font-size-medium-title font-600 mb-3'>We also work with:</div>
				<div className={classNames(styles.grid,'row no-gutter')}>
					{weAlsoWorkWith.map((item) => (
						<div className="col-12 col-lg-4 pt-4 px-lg-5" key={item.title}>
							<img className='mb-4' src={item.icon} />
							<div className='font-size-22 font-600 orange-font mb-2'>{item.title}</div>
							<div className='font-size-sm'>{item.description}</div>
						</div>
					))}
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
